import React, {
    forwardRef, useImperativeHandle, useRef, useEffect,
} from 'react';

import dialogPolyfill from 'dialog-polyfill-universal';
import ReactDOM from 'react-dom';

import { combineClasses } from 'wanderu-css';

import { CloseIcon } from '../Icons';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './ModalOverlay.scss';

const ModalOverlay = forwardRef((
    {
        children,
        classes: classesProp,
        id,
        onClick: handleClick = () => {},
        onClose,
    },
    ref,
) => {
    const modalRef = useRef(null);
    useEffect(() => {
        const dialogElem = document.querySelector('dialog');
        dialogPolyfill.registerDialog(dialogElem);
    }, []);

    useImperativeHandle(
        ref,
        () => {
            return {
                showModal() {
                    if (modalRef?.current) {
                        modalRef.current.showModal();
                    }
                },
            };
        },
        [],
    );

    const classes = combineClasses(styles, classesProp);

    const onClick = () => {
        handleClick();
        onClose();
        if (modalRef?.current) {
            modalRef.current.close();
        }
    };

    return ReactDOM.createPortal(
        <dialog
            className={classes.dialog}
            id={id}
            ref={modalRef}
        >
            <button className={classes.closeButton} onClick={onClick}>
                <CloseIcon />
            </button>
            {children}
        </dialog>,
        document.body,
    );
});

ModalOverlay.displayName = 'ModalOverlay';

export default ModalOverlay;
